module.exports = __webpack_public_path__ + "static/media/card.596e1ee9.png";